
export interface CurrencyAttributes {
  decimal_mark: string;
  iso_code: string;
  subunit: string;
  subunit_to_unit: number;
  thousands_separator: string;
  symbol?: string;
}

export const USD_ATTRIBUTES: CurrencyAttributes = {
  decimal_mark: '.',
  iso_code: 'USD',
  subunit: 'cent',
  subunit_to_unit: 100,
  thousands_separator: ',',
  symbol: '$',
};

export class Currency implements CurrencyAttributes {
  decimal_mark: string;
  iso_code: string;
  subunit: string;
  subunit_to_unit: number;
  thousands_separator: string;
  symbol?: string;
  
  constructor(attributes?: CurrencyAttributes) {

    if (!attributes) { attributes = USD_ATTRIBUTES; }

    this.decimal_mark = attributes.decimal_mark;
    this.iso_code = attributes.iso_code;
    this.subunit = attributes.subunit;
    this.subunit_to_unit = attributes.subunit_to_unit;
    this.thousands_separator = attributes.thousands_separator;
    this.symbol = attributes.symbol ?? '';
  }
 
}

